import type { Transition } from "motion/react";

/**
 * The house springs (CreativeOS Library.lib.pen, Foundations / Motion). Three
 * springs cover the product, all critically damped (bounce 0): they carry
 * velocity and can be interrupted, but never pass their target. Written as
 * visualDuration so design and code share one number. CSS transitions use the
 * same curves through --spring-snappy, --spring-smooth and --spring-gentle
 * (index.css). Under <MotionConfig reducedMotion="user"> (app root) transform
 * and layout animation switch off; opacity and colour remain.
 */

/** Press, release, toggles, chips, checkbox, menu open. */
export const SPRING_SNAPPY = { type: "spring", visualDuration: 0.18, bounce: 0 } as const satisfies Transition;

/** Sheets, menus, rail, agent dock, floating bar, toasts. */
export const SPRING_SMOOTH = { type: "spring", visualDuration: 0.32, bounce: 0 } as const satisfies Transition;

/** A card into its detail, view changes, a title settling. */
export const SPRING_GENTLE = { type: "spring", visualDuration: 0.45, bounce: 0 } as const satisfies Transition;

/**
 * A plane let go after a drag (Figma 05 · C3, the phone sheet): the one spring
 * with a give, under 4px past its stop. CSS: --spring-throw.
 */
export const SPRING_THROW = { type: "spring", visualDuration: 0.38, bounce: 0.15 } as const satisfies Transition;

/** The press: buttons and cards settle to 97% on touch-down, before the network answers. */
export const PRESS_SCALE = 0.97;

/**
 * Motion is reduced: by the OS, or by Settings → Appearance (which marks the
 * root, see CockpitLayout). For animations started from script (`el.animate`),
 * which neither MotionConfig nor the CSS override reaches.
 */
export function motionReduced(): boolean {
  return (
    document.documentElement.dataset.coMotion === "reduce" ||
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}
